import type { FaireProductEntity } from "../../entity_types/product";

export const p_yspxxv35ej: FaireProductEntity = {
  token: "p_yspxxv35ej",
  type: "product",
  name: "Awesome Opossum 15oz Ceramic Coffee Mug",
  brandToken: "b_557ocq7k0h",
  brandName: "Allegheny Outfitters",
  imageUrl: "https://cdn.faire.com/fastly/ba0fdc6d6cae33de963c558cb905a617e19cb3538cc6b4f22842f6bc96dad4e8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/05f2b5effbe2e277583f24d142fdad4a976247766af484be17e2235360f1b9a5.jpeg",
    "https://cdn.faire.com/fastly/184e87ec41b5e675ffc0f1573f72d8d716b85b060a48d968ec03c8ffea74eb50.jpeg"
  ],
  priceDollars: 13.86,
  description: "Arguably the most misunderstood critter wandering around the forest and river's edge, we find the opossum to be awesome!\n\n15oz. Hand wash recommended.",
  tags: [],
  msrpDollars: 24.94,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:00:10.820Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
